const { LOCALES } = require('./locales');

const LABELS = {
    [LOCALES.EN]: 'EN',
    [LOCALES.DE]: 'DE',
    [LOCALES.ES]: 'ES',
    [LOCALES.FR]: 'FR',
    [LOCALES.IT]: 'IT',
    [LOCALES.NL]: 'NL',
    [LOCALES.PT]: 'PT'
};

module.exports = {
    LABELS
};
